module.exports = __webpack_public_path__ + "img/banner.25ef7338.png";